import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, LogOut } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from '@/components/ui/sheet';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';

import { NavLinks } from './NavLinks';
import { ModeToggle } from '@/components/layout/shared_components/mode-toggle';

import logo from '@/assets/waterflai.svg';
import { useNavigate } from 'react-router-dom';

const Header: React.FC = () => {
  const [isSheetOpen, setIsSheetOpen] = useState(false);
  const navigate = useNavigate();

  const handleSheetClose = () => {
    setIsSheetOpen(false);
  };

  const handleLogout = () => {
    // Clear admin auth token from localStorage
    localStorage.removeItem('adminToken');
    // Redirect to admin login
    navigate('/login');
  };

  return (
    <header className="sticky top-0 flex h-16 items-center gap-4 border-b bg-background px-4 md:px-6 z-50">
      <Sheet open={isSheetOpen} onOpenChange={setIsSheetOpen}>
        <SheetTrigger asChild>
          <Button variant="outline" size="icon" className="shrink-0 md:hidden">
            <Menu className="h-5 w-5" />
            <span className="sr-only">Toggle navigation menu</span>
          </Button>
        </SheetTrigger>
        <SheetContent side="left">
          <SheetHeader>
            <SheetTitle>Admin Menu</SheetTitle>
          </SheetHeader>
          <NavLinks isMobile onItemClick={handleSheetClose} />
        </SheetContent>
      </Sheet>

      <Link to="/" className="flex items-center gap-2 text-lg font-semibold">
        <div className="w-32 h-6 relative">
          <img 
            src={logo} 
            alt="Waterflai logo" 
            className="absolute top-0 left-0 w-full h-full object-contain dark:invert" 
          />
        </div>
        <span className="sr-only">Waterflai Admin</span>
        <span className="text-sm text-muted-foreground">Admin</span>
      </Link>

      <div className="flex flex-1 justify-center">
        <nav className="hidden flex-col gap-6 text-lg font-medium md:flex md:flex-row md:items-center md:gap-5 md:text-sm lg:gap-6">
          <NavLinks />
        </nav>
      </div>
      <div className="flex items-center gap-4 md:gap-2 lg:gap-4">
        <ModeToggle />
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="icon">
              <span className="sr-only">User menu</span>
              <div className="rounded-full bg-primary text-primary-foreground size-8 flex items-center justify-center">
                <span className="text-xs font-medium">A</span>
              </div>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem onClick={handleLogout} className="cursor-pointer">
              <LogOut className="mr-2 h-4 w-4" />
              <span>Logout</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
};

export default Header;